export default __webpack_public_path__ + "static/media/uploader-oneTouchVerio-2.c9cbb696.png";